import React from "react";
import { useFormContext } from "react-hook-form";
import SurveyFormField from "../../../../shared/components/surveyFormField/SurveyFormField";
import CheckMark from "../../../../assets/icons/auth-form/check-mark.png";
import CrossMark from "../../../../assets/icons/auth-form/cross-mark.png";
import { getOptionsFromEnums } from "../../../../shared/utility";
import { preferenceEnums } from "../../../../system/global-enums";
import { EMPTY_STRING } from "../../../../constants";

const options = getOptionsFromEnums(preferenceEnums.DECISION_CHOICES_BOOLEAN);
const OwnHome = () => {
  const {
    formState: { errors },
  } = useFormContext();
  return (
    <div>
      <div className="question-heading">
        Do you currently own a home? <span>(Optional)</span>
      </div>
        {errors.ownsHouse && (
          <div className="error">{errors.ownsHouse.message}</div>
        )}
      <div className="form-fields">
        {options.map((option) => (
          <SurveyFormField
            variant="radio"
            name="ownsHouse"
            label={option.label}
            value={option.value}
            endAdornment={
              <div className="position-absolute marks-adornment">
                <img src={Number(option.value) === 1 ? CheckMark : CrossMark} alt={EMPTY_STRING} />
              </div>
            }
          />
        ))}
      </div>
    </div>
  );
};

export default OwnHome;
